import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { FirebaseService } from '../../service/firebase.service';
import { NgForm } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
//import * as  path  from 'path'

import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray
} from "@angular/forms";
import { SharedService } from 'src/app/services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalMainComponent } from 'src/app/modals/modal-main/modal-main.component';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { TranslationPipe } from '../../shared/pipes/translation.pipe';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-kiosk',
  templateUrl: './kiosk.component.html',
  styleUrls: ['./kiosk.component.scss']
})
export class KioskComponent implements OnInit {
  panelOpenState = false;
  group: string;
  device:string;
  dialogRef: any;
  mediaActive: boolean = false;
  latestUpdate: any;
  moduleId: any;
  disableModification: boolean = false;
  isSoloKiosk: boolean = false;
  @ViewChild('form') form;


  oldConfig: any;
  imgList: any = [];
  configForm: any = {
    colorText: '', backgroundURL: '', urlConfig: [
    ]
  }


  constructor(
    private firebaseService: FirebaseService,
    public sharedService:SharedService,
    public dialog: MatDialog,
    public translation: TranslationPipe,
    private _snackBar: MatSnackBar) {
    this.group = this.sharedService.selectedDevice.data.group;
    this.device = this.sharedService.selectedDevice.data.name;
   // console.log("USER DATA:", this.firebaseService.user)
    if (this.sharedService.selectedDevice.data.modules.media) {
      this.mediaActive = true;
      //   this.firebaseService.sendUpdateToMedia(this.sharedService.selectedDevice.data.group, this.sharedService.selectedDevice.data.name)
      // this.firebaseService.changeWebviewMediaModule(this.oldConfig.urlConfig[res.index], this.device, this.group, newConfig)
    }
  //  console.log(this.sharedService.selectedDevice.data.modules)
    if (this.sharedService.selectedDevice.data.modules.solokiosk) {

      this.isSoloKiosk = this.sharedService.selectedDevice.data.modules.solokiosk;
   //   console.log("isSoloKiosk", this.isSoloKiosk)
    }
  }
  /**
   * Add new url to local form
   * */
  addUrl() {
    this.configForm.urlConfig.push({ name: '', url: '', thumbnailUrl: '' })
  }

  /**
   * Remove url and update config
   * @param config Current kiosk configuration
   */
  removeUrl(config) {


    this.dialogRef = this.dialog.open(ConfirmModalComponent, {

      height: '350px',
      data: { title: this.translation.transform('confirmDeleteKiosk') }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.configForm.urlConfig.forEach((item, index, object) => {
          if (item === config) {
            object.splice(index, 1);
          }
        })

        this.oldConfig = this.configForm;
        if (config.thumbnailUrl != undefined && config.thumbnailUrl.length > 0)
        this.firebaseService.removeImg(config.thumbnailUrl)
        this.submit(null)
      }

    })
      }


  /**
   * Save new config to firestore ans uplaod new file if necessary
   * @param res
   */
  submit(res: any) {
    let file
    if(res != null)
     file = res.eventFile;


    this.disableModification = true;
    this.firebaseService.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId, 'modules').then(d => {





      if (file != undefined) {

        let filename = new Date().getTime() + file.name;
        this.firebaseService.uploadFilesCustomName(file, 'kiosk/webshot', new Date().getTime() + file.name).then(data => {

          //  console.log('OLD CONFIG', this.oldConfig)

          //   let oldConfig = this.oldConfig.urlConfig[res.index];
          if (this.configForm.urlConfig[res.index].thumbnailUrl != undefined && this.configForm.urlConfig[res.index].thumbnailUrl.length > 0)
            this.firebaseService.removeImg(this.configForm.urlConfig[res.index].thumbnailUrl)


          this.configForm.urlConfig[res.index].thumbnailUrl = data;
          this.configForm.urlConfig[res.index].filename = filename

          this.configForm.urlConfig.forEach(elem => {
            //    console.log(elem)
            if (elem.id == undefined) {
              elem.id = uuidv4();
            }
          })

          if (this.configForm.urlConfig[res.index].id == undefined)
            this.configForm.urlConfig[res.index].id = uuidv4();

          let newUrl = data;
          let newConfig = this.configForm.urlConfig[res.index]
          this.firebaseService.setModuleFromDevice('kiosk', this.group, this.device, this.configForm)

          if (this.sharedService.selectedDevice.data.modules.media && (this.oldConfig.urlConfig[res.index].id != undefined)) {
            this.firebaseService.changeWebviewMediaModule(this.oldConfig.urlConfig[res.index], this.device, this.group, newConfig)
          }
         // console.log(d, this.latestUpdate)
          this.latestUpdate = d;
          this.configForm.latestUpdate = d;
          this.disableModification = false;
        })

      }
      else {

        this.configForm.urlConfig.forEach(elem => {
          //  console.log(elem)
          if (elem.id == undefined) {
            elem.id = uuidv4();
          }
        })

        //console.log(res, this.configForm.urlConfig[res.index])
        if (res != null && res != undefined && this.configForm.urlConfig[res.index] != undefined) {
          if (this.configForm.urlConfig[res.index].id == undefined)
            this.configForm.urlConfig[res.index].id = uuidv4();
        }



        this.firebaseService.setModuleFromDevice('kiosk', this.group, this.device, this.configForm);
        //  console.log(res)

        if (res != null && res != undefined && this.configForm.urlConfig[res.index] != undefined) {
          let newConfig = this.configForm.urlConfig[res.index]
          if (this.oldConfig.urlConfig[res.index].id != undefined)
            this.firebaseService.changeWebviewMediaModule(this.oldConfig.urlConfig[res.index], this.device, this.group, newConfig)

        }
        //console.log(d, this.latestUpdate)
        this.latestUpdate = d;
        this.configForm.latestUpdate = d;
        this.disableModification = false;

      }

    })




  }



  applyToAllDeviceFromGroup() {
    //console.log(this.configForm)


    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmOperation'), ok: 'OK', cancel: this.translation.transform('cancel') }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.firebaseService.updateKioskSettingsOfAllGroup(this.configForm, this.sharedService.selectedDevice.data.group, this.sharedService.selectedDevice.data.name)
      }

      else {

      }

    })




  }


 /* addToFilesList(e, folder, item) {

    this.imgList.push({ event: e, folder: folder, item: item });
  }*/

  ngOnInit() {


    this.firebaseService.getModuleFromDevice('kiosk', this.group, this.device).then(data => {
      if (data != undefined)
        this.configForm = data.data;
      if (this.configForm.urlLock == undefined)
        this.configForm.urlLock = true;

      this.latestUpdate = data.data.latestUpdate;
      this.moduleId = data.id
      //console.log(this.latestUpdate)
    });
  }

  /**
   * Submit current local config
   * */
  setValue() {

  //  console.log(this.configForm)
   this.submit(this.configForm)
  }

  checkValidURL(path) {

    let url;
    try {
      url = new URL(path);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }

  /**
   * Open modal for url settings
   * @param item The url's configuration
   * @param index The url's index in config
   */
  showModal(item:any, index:number){
   // console.log(this.configForm)
    this.oldConfig = JSON.parse(JSON.stringify(this.configForm))
    let complementData = null;

    if (this.configForm.complementData)
      complementData = JSON.parse(JSON.stringify(this.configForm.complementData))

    var _data = {
      type: 'webpage',
      title:'Modifier les paramètres de la page web',
      item: item,
      index: index,
      buttonLabel: 'Valider',
      buttonColor: 'accent',
      complement: complementData//JSON.parse(JSON.stringify(this.configForm.complementData))
    };


    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '50vh',
      data:_data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
      //  this.oldConfig = JSON.parse(JSON.stringify(this.configForm))

        //console.log(result.item)

        /*CHECK IF CORRECT URL*/
       //console.log( this.checkValidURL(result.item.url))


      //  console.log(result.item.url === path.basename(result.item.url))



        if (!this.checkValidURL(result.item.url)) {
          this._snackBar.open('L\'url n\'est pas une adresse web valide, l\'affichage peut rencontrer des problèmes.', 'OK', {
            duration: 5000
          })
        }
        this.configForm.urlConfig[result.index] = result.item
          this.submit(result);
      }

    });



  }





}
